import React from 'react'
import { Navigate } from 'react-router-dom'
import { useSuperAdminAuth } from '../contexts/SuperAdminAuthContext'
import { Shield, AlertCircle } from 'lucide-react'

const SuperAdminProtectedRoute = ({ children }) => {
  const { superAdmin, isLoading } = useSuperAdminAuth()

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verifying super admin access...</p>
        </div>
      </div>
    )
  }

  // Check if user is authenticated and is a super admin
  if (!superAdmin) {
    return <Navigate to="/adminsp" replace />
  }

  // Check if user has super admin privileges
  // This could be based on role, mgCode, or other criteria
  const isSuperAdmin = superAdmin.role === 'super_admin' || 
                       superAdmin.mgCode === 'super_admin' || 
                       superAdmin.username === 'superadmin'

  if (!isSuperAdmin) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
          <div className="mx-auto h-16 w-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <Shield className="h-8 w-8 text-red-600" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Access Denied</h2>
          <div className="flex items-center justify-center text-red-600 mb-4">
            <AlertCircle className="h-5 w-5 mr-2" />
            <span>Super Admin privileges required</span>
          </div>
          <p className="text-gray-600 mb-6">
            You don't have sufficient permissions to access this area. 
            Contact your system administrator if you believe this is an error.
          </p>
          <button
            onClick={() => window.history.back()}
            className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    )
  }

  return children
}

export default SuperAdminProtectedRoute
